export const defaultSortableOption: CMxCommonApp.SortableOption = {
  sortField: 'id',
  sortDirection: 'ASC'
};
